export default "__VITE_ASSET__9m6j8DUt__"